import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import user from "./modules/user";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: "accountsStore",
  storage: window.sessionStorage
});

export const actions = {
  ResetState(context) {
    context.commit("RESET_USER_STATE");
  }
};

export default new Vuex.Store({
  modules: {
    user
  },
  plugins: [vuexLocalStorage.plugin]
});
